




































































import { HelpCircleIcon } from 'tdesign-icons-vue';
import _ from 'lodash';
import { computed, defineComponent, reactive, ref, watch, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import IPRestrictionSubmitHandler from '../composiiton/IPRestrictionSubmitHandler';
export type IPRestrictionConfigInfo = {
  itemID?: number;
  ipString: string;
};
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    ipData: {
      required: false,
      type: Object,
      default: null,
    },
  },
  components: {
    HelpCircleIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(value) {
        context.emit('update:show', value);
      },
    });
    const headerTitle = computed(() => (isEdit.value ? i18n_t('编辑登录规则') : i18n_t('添加登录规则')));
    const ipRestrictionConfig = reactive({
      ipList: '',
    });
    const configFormTips = reactive({
      ipFormatNotice: '',
    });
    const isEdit = ref(false);
    const { ipPattern } = IPRestrictionSubmitHandler();
    const methods = {
      init() {
        isEdit.value = !_.isEmpty(props.ipData);
        if (isEdit.value) {
          ipRestrictionConfig.ipList = props.ipData.rule.startIp;
          if (props.ipData.rule.endIp) {
            ipRestrictionConfig.ipList = ipRestrictionConfig.ipList.concat(`-${props.ipData.rule.endIp}`);
          }
        } else {
          ipRestrictionConfig.ipList = '';
        }
        configFormTips.ipFormatNotice = '';
      },
      didClickCloseButton() {
        innerShow.value = false;
      },
      async saveIPList() {
        if (!this.isIpListConformRules(ipRestrictionConfig.ipList)) {
          tips.error(i18n_t('部分IP格式输入错误，需修正后保存'));
          return;
        }
        const configInfo: IPRestrictionConfigInfo = {
          ipString: ipRestrictionConfig.ipList,
        };
        if (isEdit.value) {
          configInfo.itemID = props.ipData.id;
          context.emit('submit', 'edit', configInfo);
        } else {
          context.emit('submit', 'add', configInfo);
        }
      },
      validateConfigForm() {
        configFormTips.ipFormatNotice = this.isIpListConformRules(ipRestrictionConfig.ipList)
          ? ''
          : i18n_t('部分IP格式输入错误，需修正后保存');
      },
      isIpListConformRules(ipString: string) {
        const ipList = ipString.split(';').filter((item: string) => {
          return item.length > 0;
        });
        if (isEdit.value && ipList.length > 1) {
          return false;
        }
        return ipList.every((item: string) => ipPattern.test(item) === true);
      },
    };
    watch(innerShow, () => {
      if (innerShow.value) {
        methods.init();
      }
    });
    return {
      innerShow,
      headerTitle,
      isEdit,
      ipRestrictionConfig,
      configFormTips,
      ...methods,
    };
  },
});
